module.exports = __webpack_public_path__ + "img/login-bg6.58e93c5f.png";